var map = {
	"./page1.png": "S4Pl",
	"./page10.png": "odL5",
	"./page11.png": "+eXE",
	"./page12.png": "NYTc",
	"./page13.png": "dZNk",
	"./page14.png": "MFJi",
	"./page15.png": "yxSw",
	"./page16.png": "hOsL",
	"./page17.png": "zwzn",
	"./page18.png": "pZT8",
	"./page19.png": "EwXK",
	"./page2.png": "e0ar",
	"./page20.png": "wrsR",
	"./page21.png": "/9pY",
	"./page22.png": "y+VC",
	"./page23.png": "dwnG",
	"./page24.png": "q3cq",
	"./page25.png": "1OcY",
	"./page3.png": "xATF",
	"./page4.png": "mf6X",
	"./page5.png": "0UYw",
	"./page6.png": "uH74",
	"./page7.png": "L2Pw",
	"./page8.png": "YFRI",
	"./page9.png": "J7gW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "snRk";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tax ^\.\/page.*\.png$
// module id = snRk
// module chunks = 0